
/**
 * @name crud_admin_security_users.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_admin_security_users.js
 */

//import { apiCall, getBaseDir } from './utils.js';

var getBaseDir = null, apiCall = null, getBranchNameFromId = null, userHasRole = null;

$(function () {
    import('./utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        userHasRole = utils.userHasRole;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'seguranca/usuarios')
            return;

        new AdminSecurityUsers(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class AdminSecurityUsers {
    constructor(onloadList = false, deps = {}) {
        this.deps = deps;
        this.businessId = -1;
        this.securityGroupsList = [];
        let self = this;

        if (onloadList) {
            var intv = setInterval(function () {
                if (!window._sessionData.businessBranches)
                    return;

                clearInterval(intv);

                self.businessId = window._sessionData.businessId;

                let mountBranchesSelectHtml = '';
                for (let i in window._sessionData.businessBranches) {
                    let branch = window._sessionData.businessBranches[i];
                    mountBranchesSelectHtml += `<option value="${branch.ID}">${branch.FILIAL}</option>`;
                }
                if (mountBranchesSelectHtml !== '') {
                    $('#insert_operator_business_branches').html(mountBranchesSelectHtml);
                    $('#edit_operator_business_branches').html(mountBranchesSelectHtml);
                }

                let mountInternalTicketsCategoriesSelectHtml = '';
                let hasAccessToAllCategories = userHasRole('ADMIN') || userHasRole('ADMIN_ASSISTANT');
                for (let i in window._sessionData.internalTicketsCategories) {
                    let category = window._sessionData.internalTicketsCategories[i];
                    if (!hasAccessToAllCategories && category.CATEGORIA.indexOf('Un.') === -1)
                        continue;
                    mountInternalTicketsCategoriesSelectHtml += `<option value="${category.ID}">${category.CATEGORIA}</option>`;
                }
                if (mountInternalTicketsCategoriesSelectHtml !== '') {
                    $('#edit_operator_internal_tickets_access_categories').html(mountInternalTicketsCategoriesSelectHtml);
                    $('#insert_operator_internal_tickets_access_categories').html(mountInternalTicketsCategoriesSelectHtml);
                }

                setTimeout(function () {
                    $('#insert_operator_business_branches').select2();
                    $('#edit_operator_business_branches').select2();

                    $('#edit_operator_internal_tickets_access_categories').select2();
                    $('#insert_operator_internal_tickets_access_categories').select2();
                }, 250);

                self.deps.apiCall({
                    method: 'GET',
                    endpoint: 'api/v1/business/security/groups',
                    successCallback: function (res) {
                        //console.log('security groups', res.data);

                        let mountSecurityGroupsSelectHtml = '';
                        for (let i in res.data) {
                            let group = res.data[i];
                            if (!userHasRole('ADMIN') && !userHasRole('ADMIN_ASSITANT')) {
                                if (group.ROLE != 'COMMERCIAL_ASSISTANT' && group.ROLE != 'DOCTOR' && group.ROLE != 'DOCTOR_2') {
                                    continue;
                                }
                            }
                            mountSecurityGroupsSelectHtml += `<option value="${group.GROUP_ID}">${group.DESCRIPTION}</option>`;
                        }
                        $('#insert_operator_roles').html(mountSecurityGroupsSelectHtml);
                        $('#edit_operator_roles').html(mountSecurityGroupsSelectHtml);
                        setTimeout(function () {
                            $('#insert_operator_roles').select2();
                            $('#edit_operator_roles').select2();
                        }, 250);

                        self.securityGroupsList = res.data;

                        self.getBusinessUsers()
                            .then(() => {
                                //console.log('render getBusinessUsers list')
                            })
                            .then(() => {
                                self.bindElementsChanges();
                            });
                    },
                    errorCalback: function (res) {

                    }
                });
            }, 1000);
        }
    }

    getBusinessUsers() {
        let self = this;
        return new Promise((resolve, reject) => {
            $(".js-security-users-table").block(window._loader.loading);

            this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/security/users',
                successCallback: function (res) {
                    resolve(true);

                    let tableHtml = '';
                    for (let i in res.data) {
                        let user = res.data[i];
                        tableHtml += `
                            <tr>
                                <td data-label="#">${user.ACTIVE == 'N' ? '🔴' : '🟢'} ${user.LOGIN}</td>
                                <td data-label="Cargos">${self.getUserGroupListHTMLTags(user.GROUP_ID ? user.GROUP_ID.split(',') : [])}</td>
                                <td data-label="Filiais">${self.getUserBranchesListHTMLTags(user.FILIAL_ID ? user.FILIAL_ID.split(',') : [])}</td>
                                <td data-label="Ações">
                                    <div class="dropdown">
                                        <button class="btn btn-primary dropdown-toggle" type="button" id="dropdown-user-${user.LOGIN}" data-bs-toggle="dropdown" aria-expanded="false">
                                            Ações
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="dropdown-user-${user.LOGIN}">
                                            <li><a class="dropdown-item js-update-security-user-data" href="#" data-user-data='${JSON.stringify(user)}' data-bs-target="#modal-update-business-security-user" data-bs-toggle="modal">Editar</a></li>
                                            <li class="d-none"><a class="dropdown-item js-delete-security-user" href="#" data-user-id='${user.LOGIN}'>Excluir</a></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        `;
                    }
                    $('.js-security-users-list').html(tableHtml);
                    $(".js-security-users-table").unblock();

                    self.deps.apiCall({
                        method: 'GET',
                        endpoint: 'api/v1/employee/all',
                        successCallback: function (res) {
                            //console.log('all staff ids', res.data);

                            let mountSecurityStaffsSelectHtml = '';
                            for (let i in res.data) {
                                let group = res.data[i];
                                let branchName = getBranchNameFromId(group.FILIAL_ID);
                                mountSecurityStaffsSelectHtml += `<option value="${group.ID}">${group.PRIMEIRO_NOME} ${group.SOBRENOME} (${branchName})</option>`;
                            }
                            $('#insert_operator_staff_ids').html(mountSecurityStaffsSelectHtml);
                            $('#edit_operator_staff_ids').html(mountSecurityStaffsSelectHtml);
                            setTimeout(function () {
                                $('#insert_operator_staff_ids').select2();
                                $('#edit_operator_staff_ids').select2();
                            }, 250);

                            self.securityStaffList = res.data;
                        },
                        errorCalback: function (res) {

                        }
                    });
                },
                errorCalback: function (err) {
                    reject(false)
                }
            });
        });
    }

    getUserGroupListHTMLTags(list) {
        let html = '';
        for (let i in list) {
            for (let x in this.securityGroupsList) {
                let secGroup = this.securityGroupsList[x];
                if (secGroup.GROUP_ID == list[i]) {
                    html += `<span class="badge bg-primary mx-1 my-1">${secGroup.DESCRIPTION}</span>`;
                    continue;
                }
            }
        }
        return html;
    }

    getUserBranchesListHTMLTags(list) {
        let html = '';
        for (let i in list) {
            for (let x in window._sessionData.businessBranches) {
                let branch = window._sessionData.businessBranches[x];
                if (branch.ID == list[i]) {
                    html += `<span class="badge bg-primary mx-1 my-1">${branch.FILIAL}</span>`;
                    continue;
                }
            }
        }
        return html;
    }

    bindElementsChanges() {
        const self = this;

        // Detecta operador clicando para inserir operador(usuário)
        $(document).on('submit', '.js-business-security-operator-insert', function (e) {
            e.preventDefault();

            let data = $(this).serializeArray(),
                rolesKey = -1,
                businessBranchesKey = -1,
                staffIdsKey = -1,
                rolesString = '',
                businessBranchesString = '',
                staffIdString = '',
                internalTicketsString = '';
            internalTicketsKey = -1;

            for (let i in data) {
                let info = data[i];

                if (info.name == 'insert_operator_business_branches') {
                    if (businessBranchesString == '') {
                        businessBranchesString += info.value;
                        businessBranchesKey = i;
                    } else {
                        businessBranchesString += `,` + info.value;
                        delete data[i];
                    }
                }
                if (info.name == 'insert_operator_roles') {
                    if (rolesString == '') {
                        rolesString += info.value;
                        rolesKey = i;
                    } else {
                        rolesString += `,` + info.value;
                        delete data[i];
                    }
                }
                if (info.name == 'insert_operator_staff_ids') {
                    if (staffIdString == '') {
                        staffIdString += info.value;
                        staffIdsKey = i;
                    } else {
                        staffIdString += `,` + info.value;
                        delete data[i];
                    }
                }
                if (info.name == 'insert_operator_internal_tickets_access_categories') {
                    if (internalTicketsString == '') {
                        internalTicketsString += info.value;
                        internalTicketsKey = i;
                    } else {
                        internalTicketsString += `,` + info.value;
                        delete data[i];
                    }
                }
            }

            data[businessBranchesKey] = { name: 'insert_operator_business_branches', value: businessBranchesString };
            data[rolesKey] = { name: 'insert_operator_roles', value: rolesString };
            data[staffIdsKey] = { name: 'insert_operator_staff_ids', value: staffIdString };
            data[internalTicketsKey] = { name: 'insert_operator_internal_tickets_access_categories', value: internalTicketsString };
            var filtered = data.filter(function (el) {
                return el != null;
            });
            data = filtered;

            $(".modal-insert-business-security-user-dialog").block(window._loader.loading);
            apiCall({
                method: 'POST',
                endpoint: 'api/v1/business/users/create',
                data,
                successCallback: function (res) {
                    console.log('crud_admin_security_users.js/business/security/users/insert', '.js-hunter-business-operator-update', res);
                    $(".modal-insert-business-security-user-dialog").unblock();

                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        self.getBusinessUsers()
                            .then(() => {
                                //console.log('rerender getBusinessUsers list')
                            })
                        window.toast({
                            error: false,
                            text: res.message
                        })
                        $('.js-business-security-operator-insert').trigger('reset');
                        $("#modal-insert-business-security-user").modal('hide');
                        $('.js-insert-operator-internal-tickets-access-categories-container').addClass('d-none');
                    }
                },
                errorCallback: function (err) {
                    $(".modal-insert-business-security-user-dialog").unblock();
                    //$(".modal-insert-event-hunter-dialog").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                    console.error('ERROR', 'crud_admin_security_users.js/business/security/users/insert', '.js-hunter-business-operator-insert', err);
                }
            })
        });

        // Detecta operador clicando para editar operador(usuário)
        $(document).on('submit', '.js-business-security-operator-update', function (e) {
            e.preventDefault();

            let data = $(this).serializeArray(),
                rolesKey = -1,
                businessBranchesKey = -1,
                staffIdsKey = -1,
                rolesString = '',
                businessBranchesString = '',
                staffIdString = '',
                internalTicketsString = '';
            internalTicketsKey = -1;

            for (let i in data) {
                let info = data[i];

                if (info.name == 'edit_operator_business_branches') {
                    if (businessBranchesString == '') {
                        businessBranchesString += info.value;
                        businessBranchesKey = i;
                    } else {
                        businessBranchesString += `,` + info.value;
                        delete data[i];
                    }
                }
                if (info.name == 'edit_operator_roles') {
                    if (rolesString == '') {
                        rolesString += info.value;
                        rolesKey = i;
                    } else {
                        rolesString += `,` + info.value;
                        delete data[i];
                    }
                }
                if (info.name == 'edit_operator_staff_ids') {
                    if (staffIdString == '') {
                        staffIdString += info.value;
                        staffIdsKey = i;
                    } else {
                        staffIdString += `,` + info.value;
                        delete data[i];
                    }
                }
                if (info.name == 'edit_operator_internal_tickets_access_categories') {
                    if (internalTicketsString == '') {
                        internalTicketsString += info.value;
                        internalTicketsKey = i;
                    } else {
                        internalTicketsString += `,` + info.value;
                        delete data[i];
                    }
                }
            }

            data[businessBranchesKey] = { name: 'edit_operator_business_branches', value: businessBranchesString };
            data[rolesKey] = { name: 'edit_operator_roles', value: rolesString };
            data[staffIdsKey] = { name: 'edit_operator_staff_ids', value: staffIdString };
            data[internalTicketsKey] = { name: 'edit_operator_internal_tickets_access_categories', value: internalTicketsString };
            var filtered = data.filter(function (el) {
                return el != null;
            });
            data = filtered;

            data.push({
                name: 'edit_operator_login_id',
                value: self.editSecurityUserId
            });

            $(".modal-update-business-security-user-dialog").block(window._loader.loading);
            apiCall({
                method: 'POST',
                endpoint: 'api/v1/business/users/update',
                data,
                successCallback: function (res) {
                    console.log('crud_admin_security_users.js/business/security/users/update', '.js-hunter-business-operator-update', res);
                    $(".modal-update-business-security-user-dialog").unblock();

                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        self.getBusinessUsers()
                            .then(() => {
                                //console.log('rerender getBusinessUsers list')
                            })
                        window.toast({
                            error: false,
                            text: res.message
                        })
                        $(".js-business-security-operator-update").trigger('reset');
                        $("#modal-update-business-security-user").modal('hide');
                        $('.js-edit-operator-internal-tickets-access-categories-container').addClass('d-none');
                    }
                },
                errorCallback: function (err) {
                    $(".modal-update-business-security-user-dialog").unblock();
                    //$(".modal-update-event-hunter-dialog").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                    console.error('ERROR', 'crud_admin_security_users.js/business/security/users/update', '.js-hunter-business-operator-update', err);
                }
            })
        });

        // Detecta operador clicando para modificar um grupo(cargo)
        $(document).on('click', '.js-update-security-user-data', function () {
            let userData = $(this).data('user-data');

            self.editSecurityUserId = userData.LOGIN;

            $('.js-update-business-security-user-dialog-title-id').html(self.editSecurityUserId);
            $('input[name="edit_operator_login"]').val(userData.LOGIN);
            $('input[name="edit_operator_name"]').val(userData.NAME);
            $('input[name="edit_operator_email"]').val(userData.EMAIL);
            $('select[name="edit_operator_roles"]').val(userData.GROUP_ID ? userData.GROUP_ID.split(',') : '').trigger('change');
            $('select[name="edit_operator_business_branches"]').val(userData.FILIAL_ID ? userData.FILIAL_ID.split(',') : '').trigger('change');
            $('select[name="edit_operator_staff_ids"]').val(userData.COLABORADOR_ID ? userData.COLABORADOR_ID.split(',') : '').trigger('change');
            $('select[name="edit_operator_active"]').val(userData.ACTIVE);

            if (userData.INTERNAL_TICKETS_ACCESS == 1) {
                $('#edit_operator_internal_tickets_access').prop('checked', true);
                $('.js-edit-operator-internal-tickets-access-categories-container').removeClass('d-none');
            } else {
                $('#edit_operator_internal_tickets_access').prop('checked', false);
                $('.js-edit-operator-internal-tickets-access-categories-container').addClass('d-none');
            }

            if (userData.INTERNAL_TICKETS_CATEGORIES) {
                $('#edit_operator_internal_tickets_access_categories').val(userData.INTERNAL_TICKETS_CATEGORIES.split(',')).trigger('change');
            } else {
                $('#edit_operator_internal_tickets_access_categories').val([]).trigger('change');
            }
        });

        $(document).on('change', '#insert_operator_internal_tickets_access', function () {
            if ($(this).prop('checked')) {
                $('.js-insert-operator-internal-tickets-access-categories-container').removeClass('d-none');
            } else {
                $('.js-insert-operator-internal-tickets-access-categories-container').addClass('d-none');
                $('#insert_operator_internal_tickets_access_categories').val([]).trigger('change');
            }
        });

        $(document).on('change', '#edit_operator_internal_tickets_access', function () {
            if ($(this).prop('checked')) {
                $('.js-edit-operator-internal-tickets-access-categories-container').removeClass('d-none');
            } else {
                $('.js-edit-operator-internal-tickets-access-categories-container').addClass('d-none');
                $('#edit_operator_internal_tickets_access_categories').val([]).trigger('change');
            }
        });
    }
}